import React, { useState } from 'react';
import styles from "./PromotionalLinks.module.scss";
import { Button, Input, Table } from 'reactstrap';

const PromotionalLinks = () => {
    const [generatedUrl, setGeneratedUrl] = useState("http://top-categories.maelano.com");
    const [affiliateLinks, setAffiliateLinks] = useState([
        {
            name: "Dashboard",
            url: "http://top-categories.maelano.com/?affcode=955437_nydorbi0",
        },
        {
            name: "Dashboard",
            url: "http://top-categories.maelano.com/?affcode=955437_nydorbi0",
        },
        {
            name: "Dashboard",
            url: "http://top-categories.maelano.com/?affcode=955437_nydorbi0",
        },
    ]);

    const handleCopy = (url) => {
        navigator.clipboard.writeText(url);
        alert("Link copied to clipboard!");
    };

    const handleGenerate = () => {
        if (!generatedUrl.startsWith("http://") && !generatedUrl.startsWith("https://")) {
            alert("Please enter a valid URL starting with http:// or https://");
            return;
        }

        const newAffiliateUrl = `${generatedUrl}?affcode=955437_nydorbi0`;
        setAffiliateLinks([...affiliateLinks, { name: "Generated Link", url: newAffiliateUrl }]);
    };

    return (
        <div className={styles.promotionalLinksContainer}>
            <p className={styles.description}>
                Copy and share your affiliate links or use the link generator to create new links.
            </p>

            <div className={styles.linksTableContainer}>
                <Table className={styles.table}>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>URL</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {affiliateLinks.map((link, index) => (
                            <tr key={index}>
                                <td>{link.name}</td>
                                <td>{link.url}</td>
                                <td>
                                    <Button
                                        color="link"
                                        className={styles.copyBtn}
                                        onClick={() => handleCopy(link.url)}
                                    >
                                        Copy
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            <div className={styles.urlGeneratorTable}>
                <Table className={styles.table}>
                    <thead>
                        <tr>
                            <th>Generate URL</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <p className={styles.generateUrlText}>
                                    Enter a URL (website, blog, etc.) starting with http:// or https://
                                </p>
                                <Input
                                    type="text"
                                    placeholder="Enter URL"
                                    value={generatedUrl}
                                    onChange={(e) => setGeneratedUrl(e.target.value)}
                                    className={styles.inputField}
                                />
                            </td>
                            <td>
                                <Button color="link" className={styles.generateBtn} onClick={handleGenerate}>
                                    Generate
                                </Button>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        </div>
    );
};

export default PromotionalLinks;